import { axiosInstance } from '@configs/axios/axiosInstance';

import type { EtcaRedirect } from '../types/etcaRedirect.types';

export async function getEtcaRedirect(geminiReservationId: string): Promise<EtcaRedirect> {
    const encodedId = encodeURIComponent(geminiReservationId);
    const response = await axiosInstance.get<EtcaRedirect>(`/etca-redirect/${encodedId}`);
    return response.data;
}
